import * as React from 'react'
import { styled } from 'next-yak'

import * as accounting from './index.ts'

export class LocaleMoneyFormatProvider extends React.Component {
  render() {
    return this.props.children(
      accounting.localeCurrencySettings({
        currency: this.props.currency,
        lang: this.props.lang,
      }),
    )
  }
}

LocaleMoneyFormatProvider.defaultProps = {
  currency: 'USD',
  lang: 'en',
}

/**
 *
 * @param {*} props
 * @returns
 */
export const FormatedMoney = ({ amount, symbol, precision, thousand, decimal, format }) => {
  return (
    <React.Fragment>
      {accounting.baseformatMoney(amount, { symbol, precision, thousand, decimal, format })}
    </React.Fragment>
  )
}

FormatedMoney.defaultProps = {
  amount: 0,
}

export class MoneyExchangeProvider extends React.Component {
  render() {
    const { rates, amount, from, to, children } = this.props

    return children(accounting.convertMoney(amount, { from, to, rates }))
  }
}

MoneyExchangeProvider.defaultProps = {
  amount: 0,
}

// NOTE: number must be a non-breaking word
export const MoneyWrapper = styled.span`
  display: inline-block;
  text-decoration: inherit;
  color: inherit;
`

/**
 *
 * @param {{ value: React.ReactNode }} props
 * @returns
 */
export function Money({ value }) {
  return <MoneyWrapper>{value}</MoneyWrapper>
}

/** Money, money ! */
export class LocaleMoneyDisplayer extends React.Component {
  render() {
    const { rates, amount, currency, includesRoundedSymbol, targetCurrency, localeFormat, precision } = this.props

    return (
      <MoneyWrapper>
        {accounting.localeMoney(
          amount,
          {
            precision,
            targetCurrency,
            lang: localeFormat,
            currency,
            rates,
          },
          includesRoundedSymbol,
        )}
      </MoneyWrapper>
    )
  }
}

LocaleMoneyDisplayer.defaultProps = {
  amount: 0,
  localeFormat: 'en',
}

LocaleMoneyDisplayer.displayName = 'legacy.LocaleMoneyDisplayer'
